import React from 'react'
import SlideImage from '../components/SlideImage'
import SlideVideo from '../components/SlideVideo'
import styled from 'styled-components'
import arrowKeysSource from '../images/arrow-keys.svg'

const HeaderTitleWrapper = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  z-index: 3;
  transition: opacity 500ms linear;
  display: ${props => (props.visible === true ? 'block' : 'none')};
`

const HeaderArrows = styled.div`
  margin: 0;
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translate(-50%, -8%);
  color: white;
  text-align: center;
  z-index: 3;
  transition: opacity 500ms linear;
  display: none;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: ${props => (props.visible === true ? 'block' : 'none')};
  }
`
const ArrowKeys = styled.img`
  width: 100px;
  height: 100px;
  margin: 0;
  opacity: 0.8;
  svg {
    fill: #fff;
  }
`
const HeaderTitle = styled.h1`
  margin: 0;
  font-size: 38px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 44px;
  }
  animation-duration: 1s;
  animation-delay: 1.2s;
`

const HeaderSubtitle = styled.h4`
  margin: 0;
  font-size: 22px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 26px;
  }
  animation-duration: 1s;
  animation-delay: 1.2s;
`

class Slide extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      videoStart: false,
    }
  }

  render() {
    const projectContentType = this.props.projectFiles.photo.file.contentType
    const projectFiles = this.props.projectFiles
    const slideNumber = this.props.slideNumber
    const projectId = this.props.id
    const visible = this.props.visible
    const title = this.props.title
    const dark = this.props.projectFiles.dark
    const subtitle = this.props.subtitle

    if (projectContentType === 'video/mp4' && projectId === 0) {
      return (
        <div>
          <HeaderTitleWrapper visible={visible} className="animated fadeIn">
            <HeaderTitle>{title}</HeaderTitle>
            <HeaderSubtitle>{subtitle}</HeaderSubtitle>
          </HeaderTitleWrapper>
          <HeaderArrows visible={visible} className="animated fadeIn">
            <ArrowKeys src={arrowKeysSource} alt="Arrow keys navigation" />
          </HeaderArrows>
          <SlideVideo
            id={projectId}
            slideNumber={slideNumber}
            projectVideo={projectFiles}
            visible={visible}
          />
        </div>
      )
    } else if (projectContentType === 'video/mp4') {
      return (
        <SlideVideo
          id={projectId}
          slideNumber={slideNumber}
          projectVideo={projectFiles}
        />
      )
    } else if (projectId === 0) {
      return (
        <div>
          <HeaderTitleWrapper visible={visible} className="animated fadeIn">
            <HeaderTitle>{title}</HeaderTitle>
            <HeaderSubtitle>{subtitle}</HeaderSubtitle>
          </HeaderTitleWrapper>
          <HeaderArrows visible={visible} className="animated fadeIn">
            <ArrowKeys
              src={arrowKeysSource}
              alt="Arrow keys navigation"
              className="animated bounce delay-1s"
            />
          </HeaderArrows>

          <SlideImage
            dark={dark}
            slideNumber={slideNumber}
            id={projectId}
            projectImage={projectFiles}
            visible={visible}
          />
        </div>
      )
    } else {
      return (
        <SlideImage
          dark={dark}
          slideNumber={slideNumber}
          id={projectId}
          projectImage={projectFiles}
          visible={false}
        />
      )
    }
  }
}

export default Slide
